/**
 * @generated SignedSource<<3240a6363bdd4bf1719b9fb44441ff22>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type UnlikeEpisodeInput = {
  episodeId: string;
  topicSlug: string;
};
export type EpisodeListUnlikeMutation$variables = {
  input: UnlikeEpisodeInput;
};
export type EpisodeListUnlikeMutation$data = {
  readonly unlikeEpisode: {
    readonly episode: {
      readonly id: string;
      readonly isLikedByViewer: boolean | null | undefined;
      readonly likeCount: number;
    } | null | undefined;
    readonly userErrors: ReadonlyArray<{
      readonly field: string | null | undefined;
      readonly message: string;
    }>;
  };
};
export type EpisodeListUnlikeMutation = {
  response: EpisodeListUnlikeMutation$data;
  variables: EpisodeListUnlikeMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "UnlikeEpisodePayload",
    "kind": "LinkedField",
    "name": "unlikeEpisode",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Episode",
        "kind": "LinkedField",
        "name": "episode",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isLikedByViewer",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "likeCount",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "UserError",
        "kind": "LinkedField",
        "name": "userErrors",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "message",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "field",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "EpisodeListUnlikeMutation",
    "selections": (v1/*: any*/),
    "type": "MutationRoot",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "EpisodeListUnlikeMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "670f617de5ca0bf98644cb8e573b0718",
    "id": null,
    "metadata": {},
    "name": "EpisodeListUnlikeMutation",
    "operationKind": "mutation",
    "text": "mutation EpisodeListUnlikeMutation(\n  $input: UnlikeEpisodeInput!\n) {\n  unlikeEpisode(input: $input) {\n    episode {\n      id\n      isLikedByViewer\n      likeCount\n    }\n    userErrors {\n      message\n      field\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "94a0f40314f3bd350cb316fc2500e7f5";

export default node;
